import React from "react";
import { useGlobalContext } from "./context/globalContext";

const Footer = () => {
  const { handleShowModal } = useGlobalContext();
  return (
    <>
      <section className="section shadow-sm lazyloaded" id="developer">
        <small>
          <b>Disclaimer:</b>
          This website is maintained by an authorized marketing partner
          registered under RERA. The content is for informational purposes only
          and does not constitute an offer to avail of any service. Prices and
          availability are subject to change without prior notice. All images
          are for representation purposes only. By filling out the form, you
          agree to receive communication from RERA-registered brokers/companies
          regarding project updates.
          <div className="footer-copyright">
            <span>
              {" "}
              {/* Contact Us at: MBC Center, Kapurbawdi Junction Thane (W) 400607{" "} */}
            </span>
            {/* <span> © Copyright 2024</span> */}
            <span style={{ marginBottom: "50px" }}>
              {/* <a href="about.html" target="_blank" rel="noopener noreferrer">
                About Us
              </a>{" "}
              |{" "} */}
              <a
                href="termsandconditions.html"
                target="_blank"
                rel="noopener noreferrer"
              >
                Terms &amp; Conditions
              </a>{" "}
              |{" "}
              <a href="privacy.html" target="_blank" rel="noopener noreferrer">
                Privacy Policy
              </a>{" "}
              |{" "}
              <a href="cookies.html" target="_blank" rel="noopener noreferrer">
                Cookies Policy
              </a>{" "}
            </span>
          </div>
        </small>
      </section>
      <ul className="mob-action nav nav-fill d-lg-none">
        <li
          className="nav-item enqModal"
          onClick={() => handleShowModal("Footer - Enquire Now")}
          style={{ cursor: "pointer", color: "#fff" }}
        >
          <i className="mi mi-download nav-icon d-inline-block animated slideInDown infinite"></i>{" "}
          Enquire
        </li>
        <a
          className="nav-item enqModal"
          href="https://api.whatsapp.com/send?phone=917208286812&text=Hi,%20I%20Would%20Like%20To%20Know%20More%20About Regency Anantam NXT Project.%20Please%20Share%20More%20Details!"
          style={{ textDecoration: "none", color: "#fff" }}
        >
          <span className="action-icon">
            <img src="images/wh.png" alt="logo" />
          </span>{" "}
          Whatsapp{" "}
        </a>

        <li className="nav-item">
          <a
            href="tel:+917208286812"
            style={{ textDecoration: "none", color: "#fff" }}
          >
            {" "}
            <span className="mi mi-call action-icon"></span> Call Now
          </a>
        </li>
      </ul>
    </>
  );
};

export default Footer;
